import { createFileRoute } from '@tanstack/react-router'
import { useTracking } from '@vgw/multibrand-fe-tracking'
import { useJackpotsQuery } from '@/features/jackpots/use-jackpots-query/use-jackpots-query'
import { useBrandFeatures } from '@/lib/use-brand-features'
import { HeroBanner } from '@/features/hero-banner/hero-banner'
import Lobby from '@/features/lobby/lobby'
import { LobbyRootLayout } from '../../-lobby-root-layout'
import { useOidc } from '@/features/oidc/oidc'
import { assertCanPlayBeforeLoad } from '@/features/ctrls-and-caps/assert-can-play-before-load'
import { useEffect } from 'react'
import { useCategoriesQuery } from '@/features/categories-api/use-categories-query/use-categories-query'

export const Route = createFileRoute('/_app/')({
  component: Home,
  beforeLoad: async () => {
    return assertCanPlayBeforeLoad()
  },
})

let renderedOnce = false

function Home() {
  const { track } = useTracking()
  const { isNewBrowserSession } = useOidc({ assert: 'user logged in' })

  const { isLoading, categories } = useCategoriesQuery()
  const { data: jackpots } = useJackpotsQuery()
  const brandFeatures = useBrandFeatures()

  useEffect(() => {
    const isFirstViewInNewUserSession = isNewBrowserSession && !renderedOnce

    track('Page Loaded', {
      eventData: {
        'page name': 'lobby',
        'page trigger': isFirstViewInNewUserSession
          ? 'login completed'
          : 'other',
      },
    })

    renderedOnce = true
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <LobbyRootLayout>
      <div className="w-full">
        <div className="overflow-x-clip xl:px-4">
          {brandFeatures.isHeroBannerEnabled ? (
            <HeroBanner
              page={undefined}
              placement="hero_banner"
              pageType="lobby"
            />
          ) : null}
        </div>
        <div data-chromatic="ignore">
          <Lobby
            isLoading={isLoading}
            categories={categories}
            jackpots={jackpots}
          />
        </div>
      </div>
    </LobbyRootLayout>
  )
}
